import { Component, Input, OnInit, Output, OnChanges, SimpleChanges , EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { UserPostsDataService } from '../../../services/posts.service';
import { ScoreService } from '../../../services/scores.service';
//import { PostMedia } from '../../interfaces/post-media.interface'; // Adjust the path as needed

import { GifModalComponent } from '../../../modals/gif-modal/gif-modal.component';

import *  as Classes from '../../../classes/models.classes'

@Component({
    selector: 'app-post-submit',
    templateUrl: './post-submit.component.html',
    styleUrls: ['./post-submit.component.css']
})
export class PostSubmitComponent implements OnInit, OnChanges {

    @Input() Username: string;
    @Input() UserID: number;
    //@Input() postData: Classes.ShortsPostSave;
    @Input() mediaUrls: any[] = [];  // Receives media from parent
    @Input() selectedReplyType: any = { id: 1, text: "Everyone" }; // Receives reply type from parent
    @Input() pageType!: string; 

    @Output() postContent = new EventEmitter<string>(); 
    @Output() removeMedia = new EventEmitter<number>(); // Emit index of media to remove
    //@Output() contentChanged = new EventEmitter<void>();
    //this.UserPostsDataContent.PostContent

    UserPostsData: Array<Classes.ShortsPosts>;
    UserPostsDataContent: Classes.ShortsPostSave;

    currentPage = 1;
    pageSize = 10;
    isLoading = false;
    allPostsLoaded = false; // Flag to check if all posts are loaded

    selectedScoreTypeID: number | null = null;
    //selectedScoreTypeId: number | null = null;
    selectedScoreTypeIDs: { [key: number]: number } = {};
    showDetails: { [key: number]: boolean } = {};
    selectedScoreDetails: { [key: number]: Classes.ScoreDetails[] } = {};

    reactions: any = {};

    selectedFile: File | null = null;
    selectedFileUrl: string;

    selectedGifPreviewUrl: string;
    selectedGifAnimatedUrl: string;

    public replyType: number = 1; // Default to 'Everyone'
    replyTypes = [
        { id: 1, text: 'Everyone', icon: 'path/to/everyone.svg' },
        { id: 2, text: 'Accounts You Follow', icon: 'path/to/accounts-follow.svg' },
        { id: 3, text: 'Verified Accounts', icon: 'path/to/verified-accounts.svg' },
        { id: 4, text: 'Only Accounts You Mention', icon: 'path/to/accounts-mention.svg' }
    ];

    //selectedReplyType = this.replyTypes[0];  // default to Everyone


    //mediaUrls: any[] = [];  // This will include URLs, indexing, and any relevant flags

    activeIndex: number = 0;

    responsiveOptions: any[] = [
        {
            breakpoint: '1024px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '560px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    constructor(
        private userPostsDataService: UserPostsDataService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private modalService: NgbModal


    ) { }

    ngOnInit(): void {
        this.UserPostsData = new Array<Classes.ShortsPosts>();
        this.UserPostsDataContent = new Classes.ShortsPostSave();

    }

    ngOnChanges(changes: SimpleChanges): void {
    //    if (changes['mediaUrls']) {
    //        console.log("POST SUBMIT this.mediaUrls: ", this.mediaUrls);  // Log the entire event to see what properties are available
    //    }
    }

    updateActiveIndex(event: any): void {
        this.activeIndex = event.page;
        //    this.isAtStart = activeIndex === 0;
        //    this.isAtEnd = activeIndex >= this.mediaItems.length - 2;
    }

    get isAtStart(): boolean {
        //console.log("isAtStart activeIndex: " + this.activeIndex);  // Log the entire event to see what properties are available

        if (this.activeIndex === 22 || this.activeIndex === 0) {
            return true;
        };
        return false;

    }

    get isAtEnd(): boolean {
        //console.log("isAtEnd mediaUrls.length: " + this.mediaUrls.length);  // Log the entire event to see what properties are available
        //console.log("isAtEnd activeIndex: " + this.activeIndex);  // Log the entire event to see what properties are available
        if (this.mediaUrls.length === 2 && this.activeIndex === 0) {
            return true;
        }

        if (this.mediaUrls.length === 3 && this.activeIndex === 32) {
            return true;
        }
        else if (this.mediaUrls.length === 4 && this.activeIndex === 42) {
            return true;
        }
        return false;
    }

    onCarouselClick(event: MouseEvent): void {
        event.stopPropagation();
    }

    removeMediaItem(index: number): void {
        this.removeMedia.emit(index); // Send index to parent (home component)
    }

    setReplyType(replyType: any) {
        this.selectedReplyType = replyType;
    }

    adjustTextareaHeight(event: any): void {
        event.target.style.height = 'auto';
        event.target.style.height = event.target.scrollHeight + 'px';
        this.postContent.emit(this.UserPostsDataContent.PostContent);
    }

    // Toggle play/pause for GIF at specific index
    togglePlay(index: number): void {
        const item = this.mediaUrls[index];
        if (item.isTenor) {
            item.isPlaying = !item.isPlaying;
        }
    }

    removeMediaAtIndex(index: number): void {

        //console.log(`Deleting item at index ${index}`);  // Debugging output
        if (index > -1 && index < this.mediaUrls.length) {
            this.mediaUrls.splice(index, 1);
            this.mediaUrls = [...this.mediaUrls];  // Re-assign to trigger change detection
            //console.log(`Remaining items: ${this.mediaUrls.length}`);  // Check remaining items

            // After removing the item, check if the index is still valid
            if (index >= this.mediaUrls.length) {
                // If the index is out of bounds (e.g., last item was deleted), adjust it
                index = this.mediaUrls.length - 1;
            }

            // Manage focus after a slight delay to allow UI updates
            setTimeout(() => {
                this.focusOnCarouselItem(index);
            }, 100);
        }
    }

    focusOnCarouselItem(index: number): void {
        const carouselItemElements = document.querySelectorAll('.carousel-item-focusable');
        if (carouselItemElements[index]) {
            (carouselItemElements[index] as HTMLElement).focus();
        }
    }

    refreshPosts() {
        // Emit the event to refresh posts
    //    this.contentChanged.emit();
    }

}
